module.exports = __webpack_public_path__ + "static/media/favicon.cf36e481.ico";